<head>
  <title>Followup Due Date</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb *ngIf="refreshbreadcrumb"></app-breadcrumb>
<br>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="col-md-8">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email" id="groupNameAlert"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search"  class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email"><b>Annual Ref No</b> : </label></div>
        <input type="text" class="form-control" style="padding: 6px 20px;" [(ngModel)]="annualRefNo"
          placeholder="Ref No">
      </div>
    </div>
    <br> <br> <br> <br> <br> <br> <br> <br>
    <div class="button-continer   group-dropdown-align text-center">
      <button mat-stroked-button class="addButton" (click)="genFollowupReport()">
        Generate
      </button>&nbsp;
      <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
        Reset
      </button>
    </div>
  </div>

  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>
    <div class="d-flex justify-content-between">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Default'}"
        (click)="moreActivityReportDetails('Default')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Performance'}"
        (click)="moreActivityReportDetails('Performance')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="CR Performance">
        </div>
        <p class="report_subtext">{{qmsservice.moduleName}} Performance</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Pending Actions'}"
        (click)="moreActivityReportDetails('Pending Actions')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/pending.svg" width="16px" height="16px" alt="Pending Actions">
        </div>
        <p class="report_subtext">Pending Actions</p>
      </div>

    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
        (click)="moreActivityReportDetails('Extension')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='IN'  && qmsservice.moduleName!='QI' ">
        <div class="reports_block">
          <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
        </div>
        <p class="report_subtext">Extension</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Effectiveness Check'}"
        (click)="moreActivityReportDetails('Effectiveness Check')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='AU' && qmsservice.moduleName !='OOS' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px" alt="Effectiveness check">
        </div>
        <p class="report_subtext">Effectiveness Check</p>
      </div>
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Action'}"
        (click)="moreActivityReportDetails('Action')" style=" cursor: pointer;" *ngIf="qmsservice.moduleName !='AU'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/actions.svg" width="16px" height="16px" alt="Action">
        </div>
        <p class="report_subtext">Actions</p>
      </div>
    </div>

    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Finding'}"
        (click)="auditFindingReportDetails('Finding')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/loupe.png" width="16px" height="16px" alt="Finding">
        </div>
        <p class="report_subtext">Finding</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Followup'}" (click)="auditFindingReportDetails('Followup')"
        style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/arrow.png" width="16px" height="16px" alt="Followup">
        </div>
        <p class="report_subtext">Followup</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Recommendation'}"
        (click)="auditFindingReportDetails('Recommendation')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/question.png" width="16px" height="16px" alt="Recommendation">
        </div>
        <p class="report_subtext"style="font-size: 8px;">Recommendation</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'FindingDue'}" (click)="findingDueDate('FindingDue')"
        style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/date.png" width="16px" height="16px" alt="FindingDue">
        </div>
        <p class="report_subtext">Finding Due</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'FollowupDue'}" (click)="followupDueDate('FollowupDue')"
        style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/due-date.png" width="16px" height="16px" alt="FollowupDue">
        </div>
        <p class="report_subtext">Followup Due</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
        (click)="moreActivityReportDetails('Extension')" style=" cursor: pointer;"
       >
        <div class="reports_block">
          <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
        </div>
        <p class="report_subtext">Extension</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div *ngIf="qmsservice.moduleName !='AU'" class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Deleted'}" (click)="moreActivityReportDetails('Deleted')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/delete.svg" width="16px" height="16px" alt="Deleted">
        </div>
        <p class="report_subtext">Deleted</p>
      </div>
      <div *ngIf="qmsservice.moduleName !='AU'" class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Obsoleted'}"
        (click)="moreActivityReportDetails('Obsoleted')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/obsoleted.svg" width="16px" height="16px" alt="Obsoleted">
        </div>
        <p class="report_subtext">Obsoleted</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Milestone'}"
        (click)="moreActivityReportDetails('Milestone')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
        </div>
        <p class="report_subtext">Milestone</p>
      </div>

      <div *ngIf="qmsservice.moduleName =='AU'" class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}" (click)="moreActivityReportDetails('Overdue')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
        </div>
        <p class="report_subtext">Overdue</p>
      </div>

    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}"
        (click)="moreActivityReportDetails('Overdue')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
        </div>
        <p class="report_subtext">Overdue</p>
      </div>
    </div>
  </div>
</div>
<br><br><br> <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<div class="row" *ngIf="showCharts ">
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="followupDueList.length>0 ">
      <canvasjs-chart [options]="chartOptionsForFollowupDueDate"
        [styles]="{width: '100%', height:'440px'}"></canvasjs-chart>
    </div>
    <div class="border rounded-4 p-2" *ngIf="followupDueList.length == 0 ">
      <label for=" " style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins';color:#0F3659;"><b>Followup
          DueDate</b></label>
      <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
    </div>
  </div>
</div>
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedType}} : {{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="table-container">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <table class="dynamic-table-container">
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Seq</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('seq', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Finding ID</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('findingID', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Followup ID</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('followupId', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Due Date</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('dueDateStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Due Date IN Days</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('dueDateINDays', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Annual Ref No</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('annualRefNo', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Sub Group Name</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('subGroupName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Status</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('status', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Audit Department</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('auditDepartment', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Assigned To Department</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('assignedToDepartment', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Assigned To User Details</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('assignedToUserDetails', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Responses Pending</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('responsesPending', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Assigned To </span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('assignedTo', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Completed On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('completedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Comments</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('comments', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Created By</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('createdByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Created On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('createdOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Updated By</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('updatedByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Updated On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('updatedOnStr', $event,'d')" />
        </div>
      </th>

      <th id="menu" class="sticky-col first-col"></th>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.seq }}</td>
        <td class="row-data">{{ listOfUsersData.findingId }}</td>
        <td class="row-data">{{ listOfUsersData.followupId }}</td>
        <td class="row-data">{{ listOfUsersData.dueDateStr }}</td>
        <td class="row-data">{{ listOfUsersData.duedateindays }}</td>
        <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
        <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
        <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>

               <td class="row-data">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(listOfUsersData,'ASSIGNED_TO_USER_DETAILS',listOfUsersData.assignedToUserDetails,'QMS_ALL_TASKS_FOLLOWUPS_DUEDATE_VW')">
              <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
              <span class="ms-1" style="color:azure;">View</span>
            </button>
          </div>
        </td>

               <td class="row-data">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(listOfUsersData,'RESPONSES_PENDING',listOfUsersData.responsesPending,'QMS_ALL_TASKS_FOLLOWUPS_DUEDATE_VW')">
              <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
              <span class="ms-1" style="color:azure;">View</span>
            </button>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
        <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
        <td class="row-data">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(listOfUsersData,'COMMENTS',listOfUsersData.comments,'QMS_ALL_TASKS_FOLLOWUPS_DUEDATE_VW')">
              <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
              <span class="ms-1" style="color:azure;">View</span>
            </button>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 12 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
  rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label  for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportFooterSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label  for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">       
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport"
          >
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
          </ng-template>
      </mat-slide-toggle>  
      </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label  for="email">Report Name</label>
        </div>
        <div class="col-sm-8">       
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label id="pdf-select-all" for="email">Select Column(s)</label><span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput multiple placeholder="Select" #pdf [(ngModel)]="selectedColumns"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection('pdf')"> Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{item.displayExp}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>